/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of a challenge across all MFA factor types.
 */
export enum ChallengeStatus {
    PENDING = 'pending',
    APPROVED = 'approved',
    REJECTED = 'rejected',
    FAILED = 'failed',
    RETRY_REQUIRED = 'retry_required',
    IN_PROGRESS = 'in_progress',
}
